import { CoffeeOutlineIcon } from './CoffeeOutlineIcon';

/**
 * author: Google
 * id 8994C73B-937C-4541-AAFF-6FA2CE0573DF
 * name coffee-outline
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coffee-outline.svg
 * tags
 * - Food / Drink 
 */
export const LocalCafeOutlineIcon = CoffeeOutlineIcon;
export default LocalCafeOutlineIcon